import React, {useEffect, useState} from 'react';


import * as styleUtils from '../../../../../utils/styleUtils';

import InitialUploads from '../../../../../public/images/transaction-volumes/expected-initial-uploads.svg';
import MonthlyPurchases from '../../../../../public/images/transaction-volumes/expected-monthly-purchases.svg';
import MonthlyUploads from '../../../../../public/images/transaction-volumes/expected-monthly-uploads.svg';
import publicApiService from '../../../../../services/PublicApiService';
import useNumberCounter from '../../../../hooks/useNumberCounter';
import useSessionState from '../../../../hooks/useSessionState';
import {I18nMessage} from '../../../../contexts/I18n';

import styles from './TransactionVolumes.scss';
import {useIntl} from 'react-intl';

function TransactionVolumes() {

    // const [data, setData] = useSessionState('staticTransactionVolumes', {
    const [data, setData] = useState({
        isLoading: true,
        numbers: {
            expectedInitialUploads: 5000,
            expectedMonthlyCheckouts: 20,
            expectedMonthlyUploads: 120
        }
    });

    useEffect(() => {

        // session storage
        if (!data.isLoading) {
            return;
        }

        (async () => {

            // defensive handling if API is not returning handling
            let newData = {
                ...data,
                isLoading: false
            };

            const publicData = await publicApiService.getPublicData();
            if (publicData) {
                newData = {
                    ...newData,
                    ...publicData
                };
            }
            setData(newData);
        })();

    }, []);

    const {formatNumber} = useIntl();

    let {numbers} = data;

    let expectedInitialUploads = useNumberCounter(numbers.expectedInitialUploads);
    let expectedMonthlyUploads = useNumberCounter(numbers.expectedMonthlyUploads);
    let expectedMonthlyCheckouts = useNumberCounter(numbers.expectedMonthlyCheckouts);


    if (data.isLoading) {

        return null;
    }

    return (
        <section className={styleUtils.toClasses(styles.transactionVolumes, 'container')}>

            <div className={'row'}>

                <div className={'col-12'}>

                    <h2>
                        <I18nMessage id={'page.start.static.transactions.headline'}/>
                    </h2>
                    <p>
                        <I18nMessage id={'page.start.static.transactions.text'}/>
                    </p>
                </div>

            </div>

            <div className={'row'}>

                <div className={'col-4'}>

                    <div className={'image'}>
                        <InitialUploads/>
                    </div>
                    <p>
                        <span>{formatNumber(expectedInitialUploads)}+</span>
                        <I18nMessage id={'page.start.static.transactions.number.expectedInitialUploads'}/>
                    </p>

                </div>

                <div className={'col-4'}>

                    <div className={'image'}>
                        <MonthlyUploads/>
                    </div>
                    <p>
                        <span>{formatNumber(expectedMonthlyUploads)}+</span>
                        <I18nMessage id={'page.start.static.transactions.number.expectedMonthlyUploads'}/>
                    </p>

                </div>

                <div className={'col-4'}>

                    <div className={'image'}>
                        <MonthlyPurchases/>
                    </div>
                    <p>
                        <span>{formatNumber(expectedMonthlyCheckouts)}+</span>
                        <I18nMessage id={'page.start.static.transactions.number.expectedMonthlyCheckouts'}/>
                    </p>

                </div>

            </div>
        </section>
    );
}


TransactionVolumes.propTypes = {};

TransactionVolumes.defaultProps = {};


export default TransactionVolumes;
